document.addEventListener("DOMContentLoaded", () => {
    const waitForShopifyPaymentTerms = () => {
      const el = document.querySelector("shopify-payment-terms");
        
      if (el && el.shadowRoot) {
        const target = el.shadowRoot.querySelector("span.font-bold");
        const targetSecond = el.shadowRoot.querySelector("p.font-system");
  
        if (target) {
          // Responsive font size
          const isMobile = window.matchMedia("(max-width: 768px)").matches;
  
          target.style.fontWeight = "300"; // corrected from `.weight` to `.fontWeight`
          target.style.fontFamily = "Sohne Extra Light";
          target.style.lineHeight = "120%";
          target.style.fontSize = isMobile ? "12px" : "14px";

          targetSecond.style.fontWeight = "300"; // corrected from `.weight` to `.fontWeight`
          targetSecond.style.fontFamily = "Sohne Extra Light";
          targetSecond.style.lineHeight = "120%";
          targetSecond.style.fontSize = isMobile ? "12px" : "14px";
  
          return;
        }
      }
  
      // Retry until it's available
      requestAnimationFrame(waitForShopifyPaymentTerms);
    };
  
    waitForShopifyPaymentTerms();
  });
  